import React from 'react';
import styles from "../css/Exhibition.module.css";
import { useHistory } from "react-router-dom";

import { KeyboardBackspace } from "@mui/icons-material";
import Button from "components/inputs/Button";
import ExhibitionForm from "components/form/ExhibitionForm";

import ExhibitionService from "service/apiConfig/ExhibitionService";
import { resetCreateExhibition } from "service/util/resetCreateExhibition";
import { exhibitionInfoValidation } from "service/validation/exhibitionInfoValidation";
import { useDispatch, useSelector } from "react-redux";

import Swal from "sweetalert2";
import {exhibitionServerValidation} from "../../service/validation/exhibitionServerValidation";

const ExhibitionCreate = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const type = useSelector(state => state.exhibitionData.type);
    const exhibitionRoom = useSelector(state => state.exhibitionData.exhibitionRoom);
    const subTopicList = useSelector(state => state.exhibitionData.subTopicList);
    const exhibitionImageFile = useSelector(state => state.exhibitionData.exhibitionImageFile);
    const { name, roomNo, introduction, imageAltText } = exhibitionRoom;

    const onSubmitCreateExhibition = (e) => {
        e.preventDefault();
        const formData = new FormData();
        const exhibitionRoomData = {
                "id": null,
                "seq": null,
                "roomNo":exhibitionRoom.roomNo,
                "name": exhibitionRoom.name,
                "introduction": exhibitionRoom.introduction,
                "imageUrl": null,
                "imageAltText": exhibitionRoom.imageAltText,
                "invalid":  exhibitionRoom.invalid,
                "commentator" :{ "id" : exhibitionRoom.commentator.id },
                "commentatorForKid" : type === 'kor' ? { "id" : exhibitionRoom.commentatorForKid.id } : null,
                "commentatorForBlind" : type === 'kor' ? { "id" : exhibitionRoom.commentatorForBlind.id } : null,
                "language" : { "id": type === 'kor' ? 1 : 2 },
                "parentId" : type === 'eng' ? exhibitionRoom.parentId : null
        }

        formData.append('exhibitionRoom', JSON.stringify(exhibitionRoomData));
        formData.append('roomSubTopicList', JSON.stringify(subTopicList));
        formData.append('file', exhibitionImageFile);
        if (exhibitionInfoValidation(exhibitionRoom, type, exhibitionImageFile)) {
            ExhibitionService.create(formData)
                .then(response => {
                    exhibitionServerValidation(response, history, dispatch, type);
                })
                .catch(err => console.log(err));
        }
    }
    const handleGoBack = (e) => {
        e.preventDefault();
        if (name || roomNo || introduction || imageAltText) {
            Swal.fire({
                text: "입력하신 내용을 저장하지 않고\n나가시겠습니까?",
                icon: 'warning',
                confirmButtonText: '나가기',
                cancelButtonText: '취소',
                showCancelButton: true,
            }).then(r => {
                if (r.isConfirmed) {
                    resetCreateExhibition(dispatch);
                    history.goBack();
                }
            });
        } else {
            history.goBack();
        }
    }

    return (
        <section className={`sectionWrap ${styles.exhibitionWrap}`}>
            <header>
                <h2>전시 등록</h2>
                <button onClick={(e) => {handleGoBack(e)}}><KeyboardBackspace /></button>
            </header>
            <ExhibitionForm create={true} />
            <Button onClick={onSubmitCreateExhibition} style={{ background: "#a2b521", display: "flex", marginLeft: "auto" }}>저장</Button>
        </section>
    );
};

export default ExhibitionCreate;